import styles from "./PublicProfilesGhostBox.module.css";

export default function PublicProfilesGhostBox() {
  return (
    <div className={styles.main}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="23"
        viewBox="0 0 26 23"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.3384 19.6173L14.9676 1.80615H14.9665C14.1397 0.302899 11.9598 0.302899 11.0583 1.80615L0.687482 19.6173C-0.214174 21.1207 0.913357 22.9997 2.64152 22.9997H23.3844C25.1885 22.9997 26.24 21.1206 25.3384 19.6173ZM12.7123 2.70747C12.8633 2.48159 13.2391 2.48159 13.389 2.70747H13.3903L23.761 20.5936C23.911 20.8195 23.6861 21.1953 23.3852 21.1953H2.64237C2.34152 21.1953 2.19159 20.8195 2.34152 20.5936L12.7123 2.70747Z"
          fill="#FFFFF2"
        />
        <path
          d="M12.5619 7.29102H13.4634C13.7643 7.29102 13.9892 7.36598 14.2151 7.59186C14.441 7.81774 14.5159 8.04265 14.5159 8.3435L14.0651 15.1821C14.0651 15.7079 13.6144 16.1586 13.0886 16.1586H12.9387C12.4129 16.1586 12.0371 15.7079 11.9622 15.1821L11.5863 8.3435C11.5114 8.04265 11.6613 7.81776 11.8122 7.59186C12.0381 7.36598 12.263 7.29102 12.5639 7.29102L12.5619 7.29102Z"
          fill="#FFFFF2"
        />
        <path
          d="M14.4405 18.3384C14.4405 19.1275 13.8004 19.7667 13.0123 19.7667C12.2242 19.7667 11.584 19.1275 11.584 18.3384C11.584 17.5503 12.2242 16.9111 13.0123 16.9111C13.8004 16.9111 14.4405 17.5503 14.4405 18.3384Z"
          fill="#FFFFF2"
        />
      </svg>
      <p className={styles.text}>
        You must be connected to this user to see this content.
      </p>
    </div>
  );
}
